/**
 * Language switch for the staff-facing screens. Sits in the top bar of
 * My Performance; the choice sticks on the device.
 */
import React from 'react';
import { Globe, Loader2 } from 'lucide-react';
import { LANGUAGES, useLang } from '../../i18n/LangContext';

export const LanguagePicker = ({ className = '' }) => {
  const { lang, setLang, loading } = useLang();
  return (
    <label className={`inline-flex items-center gap-1.5 ${className}`} title="Change language">
      {loading
        ? <Loader2 size={15} className="animate-spin text-teal-600" />
        : <Globe size={15} className="text-teal-600" />}
      <select
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        className="text-xs sm:text-sm bg-white border border-slate-300 rounded-lg px-2 py-1.5 text-slate-700 focus:outline-none focus:ring-2 focus:ring-teal-500/40"
        aria-label="Language"
        data-testid="language-picker"
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>{l.native}</option>
        ))}
      </select>
    </label>
  );
};

export default LanguagePicker;
